// MO4.1.2
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import TierIcon from '@wix/da-ds/pkg/Icons/16x16/Tier';
import Flex from '@wix/da-ds/pkg/Flex';
import StatisticsBar from '../Helper/StatisticsBar';
import UserIdentity from '../../User/Identity';
import TierPricePerMonth from '../Helper/TierPricePerMonth';
import TierPriceWithBadge from '../Helper/TierPriceWithBadge';
import DeviationDumbView from '../Dumbo';
import UnknownDumbo from '../Dumbo/Unknown';
import Minimal from './Minimal';
import s from './TierPromotionCardDumb.scss';
const RATIO = 1.84;
const DESCRIPTION_CUTOFF_HEIGHT = 250;
const SUPER_NARROW_WIDTH = 300;
const STATS_CUTOFF_HEIGHT = 195;
const MINIMAL_VIEW_HEIGHT = 120;
const DUMBO_MAX_WIDTH_RATIO = 0.33;
function getDimensions(width, height) {
    if (width) {
        return {
            width,
            height: width / RATIO
        };
    } else if (height) {
        return {
            width: height * RATIO,
            height
        };
    }
}
function getDumboHeight(cardHeight) {
    // spacings =  4 * 16px
    // footer block = 32px
    // borders = 2px
    return cardHeight - 4 * 16 - 32 - 2;
}
const TierPromotionCardDumb = ({ title, description, author, showAuthor = true, numSubscribers, price, coverImage, showMatureCover, hotspot, ctaButton, width, height, style, showEmptyPlaceholders, state = 'active', className, onClick, innerRef })=>{
    const { t } = useTranslation();
    const newSubscribeButtons = useFlag('subscribe_btns');
    const dimensions = getDimensions(width, height);
    if (!dimensions) {
        return null;
    }
    if (dimensions.height <= MINIMAL_VIEW_HEIGHT) {
        return /*#__PURE__*/ React.createElement(Minimal, _object_spread_props(_object_spread({
            deviation: coverImage,
            className: classnames(s['root'], className),
            onClick: onClick
        }, dimensions), {
            style: style
        }));
    }
    const stats = [
        numSubscribers !== undefined && {
            icon: TierIcon,
            label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers
            })
        }
    ].filter((stat)=>stat);
    const showDescription = description && dimensions.height >= DESCRIPTION_CUTOFF_HEIGHT;
    const showStats = stats.length > 0 && dimensions.height >= STATS_CUTOFF_HEIGHT;
    const dumboWidth = dimensions.width * DUMBO_MAX_WIDTH_RATIO;
    const dumboHeight = getDumboHeight(dimensions.height);
    const isNarrow = !!width && width < SUPER_NARROW_WIDTH;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], isNarrow && s['narrow'], className),
        style: _object_spread({}, dimensions, style),
        onClick: onClick,
        ref: innerRef
    }, /*#__PURE__*/ React.createElement(Flex, {
        className: s['details-and-thumb'],
        style: {
            maxHeight: isNarrow ? '100%' : dumboHeight
        }
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['card-details']
    }, showAuthor && author && /*#__PURE__*/ React.createElement(UserIdentity, {
        user: author,
        size: "small",
        className: s['identity']
    }), showEmptyPlaceholders && !title && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['placeholder'], s['placeholder-title'])
    }), title && /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), showStats && /*#__PURE__*/ React.createElement(StatisticsBar, {
        className: s['statistics'],
        stats: stats
    }), showDescription && /*#__PURE__*/ React.createElement("div", {
        className: s['description']
    }, description), hotspot), /*#__PURE__*/ React.createElement("div", {
        className: s['dumbo-wrapper']
    }, coverImage ? /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['dumbo'],
        deviation: coverImage,
        width: dumboWidth,
        height: dumboHeight,
        showMatureContent: showMatureCover
    }) : showEmptyPlaceholders ? /*#__PURE__*/ React.createElement("div", {
        className: s['placeholder-cover'],
        style: {
            width: dumboWidth,
            height: dumboHeight
        }
    }) : /*#__PURE__*/ React.createElement(UnknownDumbo, {
        className: s['dumbo'],
        width: dumboWidth,
        height: dumboHeight
    }), state !== 'active' && /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['state-tag'], s[state])
    }, t(`deviationview.tierCard.state.${state}`)))), /*#__PURE__*/ React.createElement("hr", {
        className: s['divider']
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center",
        className: s['price-wrapper']
    }, !!price && (isNarrow || newSubscribeButtons) ? /*#__PURE__*/ React.createElement(TierPricePerMonth, {
        className: s['price'],
        price: price
    }) : /*#__PURE__*/ React.createElement(TierPriceWithBadge, {
        className: s['price'],
        price: price,
        showPlaceholder: showEmptyPlaceholders
    }), ctaButton));
};
TierPromotionCardDumb.displayName = 'TierPromotionCardDumb';
export default TierPromotionCardDumb;
